import { Component, Inject } from '@angular/core';

import { EntityCheckboxListComponent } from '../../shared/checkbox-list/components/entity-checkbox-list.component';

import { StaticTypeService } from '../services/static-types.service';
import { ParcMaintenance } from '../entities/parc-maintenance.entity';

@Component({
	selector: 'parc-maintenance-checkbox-list',
	templateUrl: '../../shared/checkbox-list/components/entity-checkbox-list.html',
	styleUrls: ['../../shared/checkbox-list/components/entity-checkbox-list.css']
})
export class ParcMaintenanceCheckboxListComponent extends EntityCheckboxListComponent<ParcMaintenance> {
	// Label du champ
	override label = "Maintenance :"
	
	// Label de l'option neutre
	override wildcardOptionLabel = "Toutes"

	// Fonction determinant le label d'un parc
	override getEntityLabel = (maintenance: ParcMaintenance) => maintenance.label;

	constructor( //
		@Inject(StaticTypeService) private staticTypesService: StaticTypeService //
	) {
		super();
		this.staticTypesService.getParcMaintenanceList().subscribe(
			(list: ParcMaintenance[]) => this.entities = list
		);
	}
}